// extracted by mini-css-extract-plugin
export default {"root":"k8HJxI","listContentColor":"cXchta","icon":"hho3nL","reversedIcon":"kBM0C2"};